import { streamLainAnimationController } from '@blocksuite/affine-shared/utils';
import { ArrowRightSmallIcon } from '@blocksuite/icons/rc';
import clsx from 'clsx';
import { useLayoutEffect, useRef } from 'react';

import * as styles from './disclosure-chevron.css';

/** Canonical disclosure affordance shared by animated expandable regions. */
export function DisclosureChevron({
  expanded,
  animate = true,
  className,
  testId,
}: {
  expanded: boolean;
  animate?: boolean;
  className?: string;
  testId?: string;
}) {
  const element = useRef<HTMLSpanElement>(null);
  const angle = useRef(expanded ? 90 : 0);
  useLayoutEffect(() => {
    const node = element.current;
    if (!node) return;
    const from = angle.current;
    const target = expanded ? 90 : 0;
    const update = (value: number) => {
      angle.current = value;
      node.style.transform = `rotate(${value}deg)`;
    };
    if (!animate) {
      streamLainAnimationController.cancel(node);
      update(target);
      return;
    }
    update(from);
    if (from === target) return;
    const handle = streamLainAnimationController.animateProgress(
      node,
      progress => update(from + (target - from) * progress)
    );
    return () => handle.cancel();
  }, [animate, expanded]);
  return (
    <span
      ref={element}
      className={clsx(styles.root, className)}
      data-expanded={expanded}
      data-testid={testId}
      aria-hidden="true"
    >
      <ArrowRightSmallIcon />
    </span>
  );
}
